import Lottie from 'lottie-react';
// @mui
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import groovyWalkAnimation from '../../_json/loading-animation.json';


// ================================|| Loading Screen ||================================ //
export default function LoadingScreen({ sx, ...other }) {
  return (
    <Box
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        minHeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      <Box sx={{ width: 1, maxWidth: 100 }}>
        <Lottie animationData={groovyWalkAnimation} loop={Boolean(true)} />
      </Box>
      {/* <LinearProgress color="inherit" sx={{ width: 1, maxWidth: 360 }} /> */}
    </Box>
  );
}
